export default __webpack_public_path__ + "dist/media/Logout.792fb7df.svg";